import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'rsuite';

const StatusCell = ({ dataKey, rowData, ...props }) => (
  <Table.Cell {...props}>
    {rowData.isVisible} {rowData.isVisible ? 'Show' : 'Hide'}
  </Table.Cell>
);

StatusCell.propTypes = {
  dataKey: PropTypes.string.isRequired,
  rowData: PropTypes.shape({ isVisible: PropTypes.bool })
};

StatusCell.defaultProps = {
  rowData: null
};

export default StatusCell;
